import { render, staticRenderFns } from "./AdvProductPageSignature.vue?vue&type=template&id=7a15bedb&scoped=true"
import script from "./AdvProductPageSignature.vue?vue&type=script&lang=js"
export * from "./AdvProductPageSignature.vue?vue&type=script&lang=js"
import style0 from "./AdvProductPageSignature.vue?vue&type=style&index=0&id=7a15bedb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a15bedb",
  null
  
)

export default component.exports